export const formatNumberWithCommas = (number: number | string, precision = 2) => {
  const floatNumber = parseFloat(number.toString());
  return floatNumber.toFixed(precision).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatPrice = (price = 0, precision = 2, humanize = false) => {
  const priceInDollars = price / 100;
  const formattedPrice = priceInDollars.toFixed(precision);

  if (humanize) {
    return `$ ${formatNumberWithCommas(formattedPrice, precision)}`;
  }
  return `$ ${formattedPrice}`;
};

export const formatEmail = (email = '') => email.trim().toLowerCase();

export const formatPhone = (phone = '') => {
  let cleaned = ('' + phone).replace(/\D/g, '');

  // Check if cleaned number is of correct length
  if (cleaned.length !== 10 && cleaned.length !== 11) {
    return phone;
  }

  // If it starts with 1, remove it
  if (cleaned.length === 11 && cleaned[0] === "1") {
    cleaned = cleaned.substring(1);
  }

  // Create the formatted parts
  const areaCode = cleaned.substring(0, 3);
  const centralOfficeCode = cleaned.substring(3, 6);
  const lineNumber = cleaned.substring(6);

  return `+1 (${areaCode}) ${centralOfficeCode} ${lineNumber}`;
};

export const formatDate = (date: string, version = 1) => {
  if (version === 1) {
    return new Date(date).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } if (version === 2) {
    return new Date(date).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } else if (version === 3) {
    return new Date(date).toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit"
    });
  }
  return date;
};
